export default __webpack_public_path__ + "static/media/prescribedMedication.dc325b5f.svg";